import React from "react";
import { currentMonth, dateHasPassed } from "../helpers/DateUtils.jsx";
import { AVAILABLE_AFTER_COMPLETION } from "../helpers/AppConsts";
import UpcommingGameItem from "../upcomminggames/UpcommingGameItem";

export const hasEvents = ({ events }) =>
  !events || events.length < 0 ? false : true;

export const currentYear = new Date().getFullYear().toString();

export const hasResults = ({ event_results, event_hands }) => {
  return event_results !== AVAILABLE_AFTER_COMPLETION || event_hands !== AVAILABLE_AFTER_COMPLETION;
}


export const hasResultsAndActivated = ({
  event_activation_status,
  event_results,
}) => {
  //    debugger
  return event_activation_status === "activated";
};
// (event_activation_status === 'activated'); // && event_results !==  AVAILABLE_AFTER_COMPLETION);

export const hasNoEditEvent = ({ editEvent }) => !editEvent;

export const isCurrentYearAndMonth = (x) => {
  return (
    x.event_year === currentYear &&
    x.event_month === currentMonth() &&
    dateHasPassed(x)
  );
};

export const isCurrentYearAfterThisDate = (x) => {
  return x.event_year === currentYear && x.event_month >= currentMonth();
};

export const isCurrentYear = (x) => x.event_year === currentYear;

export const isCurrentYearButDatePassed = (x) =>
  x.event_year === currentYear && dateHasPassed(x);

export const gameViewRenderer = (events, view) => {
  let listView = {
    all: renderedFullList,
    month: renderedMonthList,
    homepage: renderedHomePageList,
    year: renderedYearList,
  };
  return listView[view](events, gameFilters[view]);
};

const gameFilters = {
  all: undefined,
  month: isCurrentYearAndMonth,
  // 'homepage': isCurrentYearButDatePassed,
  homepage: isCurrentYearButDatePassed,
  year: isCurrentYear,
};

const renderGameItem = (x) => {
  return (
    <React.Fragment>
      <UpcommingGameItem key={x.event_id} bridgeEvent={x} />
    </React.Fragment>
  );
};

const renderedFullList = (events, ...filterFunc) =>
  events.map((bridgeEvent) => {
    return renderGameItem(bridgeEvent);
  });

const filterGames = (events, filterFunc) => {
  return events
    .filter((x) => filterFunc(x))
    .map((bridgeEvent) => {
      return renderGameItem(bridgeEvent);
    });
};

const renderedMonthList = (events, filterFunc) => {
  return filterGames(events, filterFunc);
};

const renderedYearList = (events, filterFunc) => {
  return filterGames(events, filterFunc);
};

const renderedHomePageList = (events, filterFunc) => {
  return filterGames(events, filterFunc);
};
